<template>
  <div class="student-bag navigation-top-app">
    <template v-if="action != 'confirm_ok' && action != 'confirm_ko'">
      <navigation-top-app
        :app="app"
        :back="() => {
          back()
        }"
      >
        <template v-slot:center>
          <div id="navigation-center">
            {{ app.strings.app.student.practice.bag.shop.title }}
          </div>
        </template>
      </navigation-top-app>
      <transition name="fade">
        <div id="student-bag-content" class="max-width-800 margin-auto" v-if="show && !loading">
          <p class="shop-test" v-if="catalog.test_mode">{{ s.test_mode }}</p>
          <section class="shop-card" v-if="catalog.articles.length > 0">
            <div class="shop-label">{{ s.type }}</div>
            <div class="shop-types">
              <button v-for="article in catalog.articles" :key="article.id" class="shop-type" :class="{selected: form.article.id === article.id}" v-on:click="articleSelected(article)">
                <b>{{ article.name }}</b>
                <span>{{ article.classes }} {{ article.classes === 1 ? s.classes_one : s.classes_many }} · {{ article.license }} · {{ money(article.total) }}</span>
              </button>
            </div>
          </section>
          <div class="shop-empty" v-else>{{ s.closed }}</div>

          <section class="shop-card" v-if="form.article.id !== ''">
            <p class="shop-description" v-if="articleDescription">{{ articleDescription }}</p>
            <div class="shop-label">{{ s.data.quantity }}</div>
            <vue-number-input class="shop-quantity" size="small" v-model="form.quantity" :step="1" :min="1" :max="50" center controls></vue-number-input>
            <div class="shop-total">
              <span>{{ form.quantity }} × {{ money(form.article.total) }}</span>
              <b>{{ money(total) }}</b>
            </div>
            <label class="shop-legal">
              <input type="checkbox" v-model="legal.check" />
              <span>{{ s.accept }} <a v-on:click.prevent="legal.view = true">{{ s.terms }}</a></span>
            </label>
          </section>
        </div>
      </transition>
      <div class="bottom-action" v-if="show && !catalog.loading && form.article.id !== ''">
        <button class="h-button w-100" :disabled="!legal.check || form.loading" v-on:click="confirm()">
          {{ s.confirm_order }} · {{ money(total) }}
        </button>
      </div>
      <transition name="fade">
        <div id="student-bag-content" class="max-width-800 margin-auto" v-if="show && loading">
          <loader-dot :size="'16px'" :color_1="'rgb(32, 113, 183)'" :color_2="'rgb(32, 113, 183)'" />
        </div>
      </transition>

      <form ref="redsys" name="from" :action="tpvAction" method="POST" v-show="false">
        <input type="hidden" name="Ds_SignatureVersion" :value="tpv.Ds_SignatureVersion"/>
        <input type="hidden" name="Ds_MerchantParameters" :value="tpv.Ds_MerchantParameters"/>
        <input type="hidden" name="Ds_Signature" :value="tpv.Ds_Signature"/>
      </form>
    </template>
    <template v-if="action === 'confirm_ok'">
      <div class="confirm ok">
        <div></div>
        <div>
          <font-awesome-icon class="icon chevron" :icon="['fas', 'check']" />
        </div>
        <div>
          {{ app.strings.app.student.practice.bag.shop.confirm.ok }}
          <small class="confirm-note">{{ s.confirm.classes_soon }}</small>
        </div>
        <div>
          {{ app.strings.app.student.practice.bag.shop.confirm.redirect }} {{ redirect }}
        </div>
        <div></div>
      </div>
    </template>
    <template v-if="action === 'confirm_ko'">
      <div class="confirm ko">
        <div></div>
        <div>
          <font-awesome-icon class="icon chevron" :icon="['fas', 'times']" />
        </div>
        <div>
          {{ app.strings.app.student.practice.bag.shop.confirm.ko }}
        </div>
        <div>
          {{ app.strings.app.student.practice.bag.shop.confirm.redirect }} {{ redirect }}
        </div>
        <div></div>
      </div>
    </template>

    <div id="legal-view" v-if="legal.view === true" v-on:click.self="legal.view = false">
      <div>
        <div class="legal-head">
          <b>{{ s.terms }}</b>
          <button class="legal-close" :title="s.close" v-on:click="legal.view = false"><font-awesome-icon :icon="['fas', 'times']" /></button>
        </div>
        <div class="legal-text" v-html="legal.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-student-bag-shop-view',
  data () {
    return {
      show: false,
      action: '',
      redirect: 5,
      legal: {
        check: false,
        view: false,
        text: ''
      },
      form: {
        loading: false,
        quantity: 1,
        article: {
          id: '',
          name: '',
          total: 0
        }
      },
      catalog: {
        loading: false,
        test_mode: false,
        articles: []
      },
      tpv: {
        env: 0,
        Ds_SignatureVersion: "",
        Ds_MerchantParameters: "",
        Ds_Signature: ""
      }
    }
  },
  props: [
    'app'
  ],
  computed: {
    s () {
      return this.app.strings.app.student.practice.bag.shop
    },
    businessID () {
      return this.app.user && this.app.user.business ? this.app.user.business.id : 0
    },
    total () {
      return Math.round(this.form.article.total * this.form.quantity * 100) / 100
    },
    articleDescription () {
      // The description of an article may be rich text from the product editor.
      let text = new DOMParser().parseFromString(this.form.article.description || '', 'text/html').body.textContent
      return (text || '').trim()
    },
    loading () {
      if (this.catalog.loading) {
        return true
      }

      if (this.form.loading) {
        return true
      }

      return false
    },
    tpvAction () {
      if (this.tpv.env === 0) {
        return 'https://sis-t.redsys.es:25443/sis/realizarPago'
      } else {
        return 'https://sis.redsys.es/sis/realizarPago'
      }
    }
  },
  mounted () {
    this.show = true

    this.action = this.$route.query.action

    if (this.action === 'confirm_ok' || this.action === 'confirm_ko') {
      let intervalID = setInterval(() => {
        this.redirect--
        if (this.redirect === 0) {
          clearInterval(intervalID)
          this.$router.push({name: 'app.student.practice.bag.list', query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
        }
      }, 1000)
    }

    this.catalogRead()
  },
  watch: {
    // Opened straight from a link: the student's data arrives after the screen.
    businessID () {
      this.catalogRead()
    }
  },
  methods: {
    back () {
      this.$router.push({name: 'app.student.practice.bag.list', query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
    },
    // 30 → "30 €", 32.5 → "32,50 €".
    money (value) {
      let n = Number(value) || 0
      return n.toLocaleString('es-ES', {minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2}) + ' €'
    },
    // The conditions come from the school's web in Nirvana: nothing active in them.
    cleanHTML (html) {
      let doc = new DOMParser().parseFromString(html || '', 'text/html')
      doc.querySelectorAll('script, style, iframe, object, embed, link, meta, form').forEach(node => node.remove())
      doc.querySelectorAll('*').forEach(node => {
        Array.from(node.attributes).forEach(attribute => {
          let name = attribute.name.toLowerCase()
          let value = attribute.value.trim().toLowerCase()
          if (name.indexOf('on') === 0 || ((name === 'href' || name === 'src') && value.indexOf('javascript:') === 0)) {
            node.removeAttribute(attribute.name)
          }
        })
      })
      return doc.body.innerHTML
    },
    catalogRead () {
      if (this.catalog.loading || !this.businessID || this.action === 'confirm_ok' || this.action === 'confirm_ko') {
        return
      }

      this.catalog.loading = true

      this.$http.get(
        this.app.url.nirvana + '/app-shop/catalog',
        {
          params: {business: this.businessID},
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        this.catalog.loading = false
        let data = response.body && response.body.success === true ? response.body.data : null
        if (data && data.can_sell === true) {
          this.catalog.articles = data.articles
          this.catalog.test_mode = data.test_mode === true
          this.legal.text = this.cleanHTML(data.conditions)
        }
      }, () => {
        this.catalog.loading = false
      })
    },
    articleSelected (article) {
      this.form.article = article
    },
    confirm () {
      if (this.form.loading) {
        return
      }

      this.form.loading = true

      this.$http.post(
        this.app.url.nirvana + '/app-shop/order',
        {
          business: this.businessID,
          product: this.form.article.id,
          quantity: this.form.quantity,
          accepted: this.legal.check,
          return_base: window.location.origin
        },
        {
          emulateJSON: true,
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200 && response.body.success === true) {
          this.tpv = response.body.data.redsys
          setTimeout(() => {
            this.$refs.redsys.submit()
          }, 500)
        } else {
          this.form.loading = false
          this.catalog.articles = []
          this.form.article = {id: '', name: '', total: 0}
        }
      }, () => {
        this.form.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

#student-bag-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  width: 100%;
  min-height: 100%;
  padding: 72px 0 96px;
  box-sizing: border-box;
}

.shop-test {
  margin: 0;
  padding: 12px 16px;
  border: 1px solid #f0c36d;
  border-radius: 14px;
  background-color: #fff7e6;
  color: $text-color-1;
  font-size: 14px;
  line-height: 1.4;
}

.confirm-note {
  display: block;
  margin-top: 8px;
  font-size: 16px;
}

.shop-card {
  padding: 18px 16px;
  border: 1px solid $color-grey-light;
  border-radius: 20px;
  background-color: #FFFFFF;
  box-shadow: 0 12px 30px rgba(20, 67, 107, 0.06);
  box-sizing: border-box;
}

.shop-label {
  margin: 0 0 8px;
  color: $text-color-2;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.shop-types {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
}

.shop-type {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 12px 14px;
  border: 1px solid $color-grey-light;
  border-radius: 14px;
  background-color: $color-grey-light-3;
  color: $text-color-1;
  font: inherit;
  text-align: left;
}

.shop-type b {
  font-size: 15px;
}

.shop-type span {
  color: $text-color-2;
  font-size: 13px;
}

.shop-type.selected {
  border-color: $color-primary-1;
  background-color: #eaf3fb;
  box-shadow: inset 0 0 0 1px $color-primary-1;
}

.shop-empty {
  padding: 12px 0;
  color: $text-color-2;
  font-size: 14px;
}

.shop-description {
  margin: 0 0 16px;
  color: $text-color-2;
  font-size: 14px;
  line-height: 1.45;
}

.shop-quantity {
  width: 180px;
}

.shop-total {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-top: 16px;
  padding: 14px 0;
  border-top: 1px solid $color-grey-light;
  border-bottom: 1px solid $color-grey-light;
}

.shop-total span {
  color: $text-color-2;
  font-size: 14px;
}

.shop-total b {
  color: $text-color-1;
  font-family: 'Lexend', sans-serif;
  font-size: 24px;
}

.shop-legal {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  margin-top: 8px;
  font-size: 14px;
  cursor: pointer;
}

.shop-legal input {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  margin: 0;
  accent-color: $color-primary-1;
}

.shop-legal a {
  color: $color-primary-1;
  text-decoration: underline;
  cursor: pointer;
}

@media (min-width: 1024px) {
  #student-bag-content {
    max-width: 720px;
  }

  .shop-card {
    padding: 24px;
  }
}

.confirm {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.confirm.ok {
  background-color: $color-success;
}

.confirm.ko {
  background-color: $color-danger;
}

.confirm > div {
  padding: 12px 25px;
  box-sizing: border-box;
}

.confirm > div:nth-child(1) {
  flex: 1;
}

.confirm > div:nth-child(2) {
  color: #FFF;
  font-size: 100px;
}

.confirm > div:nth-child(3) {
  color: #FFF;
  font-size: 20px;
}

.confirm > div:nth-child(4) {
  color: #FFF;
  font-size: 18px;
}

.confirm > div:nth-last-of-type(1) {
  flex: 1;
}

#legal-view {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  background-color: rgba(15, 23, 42, 0.45);
  z-index: 10000;
}

#legal-view > div {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 720px;
  max-height: 100%;
  border-radius: 20px;
  background-color: #FFFFFF;
  overflow: hidden;
}

.legal-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 16px 14px 20px;
  border-bottom: 1px solid $color-grey-light;
  font-size: 16px;
}

.legal-close {
  flex: 0 0 40px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  background-color: $color-grey-light-3;
  color: $text-color-2;
  font-size: 16px;
}

.legal-text {
  padding: 16px 20px 24px;
  overflow: auto;
  font-size: 14px;
  line-height: 1.5;
}

@media (min-width: 1024px) {
  #student-bag-content {
    padding-top: 92px;
  }
}
</style>
